import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import App from "./App.tsx"
import { getDeviceId } from "./firebase/deviceId.ts"
import { MutationProvider } from "./hooks/useMutationState"
import "./index.css"
import { init as initAbsenceRequest } from "./entities/absenceRequest/absenceRequest.ts"
import { init as initUser } from "./entities/user/user.ts"
import { init as initAttendanceEvent } from "./entities/attendanceEvent/attendanceEventMeta.ts"
import { init as initSchoolYear } from "./entities/schoolYear/schoolYear.ts"
import { init as initGlobalSettings } from "./entities/globalSettings/globalSettings.ts"
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

getDeviceId()

export const queryClient = new QueryClient({
   defaultOptions: {
      queries: {
         staleTime: 60 * 60 * 1000,
         gcTime: 1000 * 60 * 60,
      },
      mutations: {
         networkMode: "always",
         retry: 1,
         retryDelay: 1000,
      },
   },
})

initUser()
initAbsenceRequest()
initAttendanceEvent()
initSchoolYear()
initGlobalSettings()

const rootElement = document.getElementById("root")
if (!rootElement) {
   throw new Error("Failed to find root element")
}

const root = createRoot(rootElement)

root.render(
   <Sentry.ErrorBoundary fallback={<p>Une erreur est survenue, veuillez recharger la page</p>}>
      <StrictMode>
         <QueryClientProvider client={queryClient}>
            <MutationProvider>
               <App />
               <ReactQueryDevtools initialIsOpen={false} />
            </MutationProvider>
         </QueryClientProvider>
      </StrictMode>
   </Sentry.ErrorBoundary>,
)
